import { useState, useEffect } from 'react'
import { useAuth } from '../contexts/AuthContext'
import logoImage from '../assets/strom2_webb.png'

export function Lobby() {
  const { user, logout } = useAuth()
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768)
    }
    
    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  return (
    <div style={{ 
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #2563eb 0%, #1e40af 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '16px',
        boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)',
        padding: isMobile ? '40px 24px' : '60px 50px',
        textAlign: 'center',
        maxWidth: '500px',
        width: '100%',
        margin: isMobile ? '16px' : '20px'
      }}>
        {/* Logo */}
        <div style={{ marginBottom: isMobile ? '32px' : '40px' }}>
          <img 
            src={logoImage} 
            alt="Ström2 Webb" 
            style={{ 
              height: isMobile ? '60px' : '80px',
              width: 'auto',
              marginBottom: isMobile ? '16px' : '20px'
            }} 
          />
        </div>

        {/* Status Icon */}
        <div style={{
          width: isMobile ? '64px' : '80px',
          height: isMobile ? '64px' : '80px',
          backgroundColor: '#dbeafe',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: isMobile ? '0 auto 24px' : '0 auto 30px',
          border: '3px solid #2563eb'
        }}>
          <span style={{
            fontSize: isMobile ? '28px' : '36px',
            color: '#1e40af'
          }}>⏳</span>
        </div>

        {/* Welcome Text */}
        <h1 style={{ 
          fontSize: isMobile ? '22px' : '28px',
          fontWeight: '700',
          color: '#1a202c',
          marginBottom: '16px',
          lineHeight: '1.2'
        }}>
          Välkommen {user?.displayName || user?.name}!
        </h1>
        
        <p style={{ 
          fontSize: isMobile ? '16px' : '18px',
          color: '#1e40af',
          marginBottom: '24px',
          fontWeight: '600'
        }}>
          Väntar på godkännande
        </p>

        <div style={{
          backgroundColor: '#dbeafe',
          border: '1px solid #3b82f6',
          borderRadius: '12px',
          padding: isMobile ? '20px' : '24px',
          marginBottom: isMobile ? '24px' : '32px'
        }}>
          <p style={{ 
            fontSize: isMobile ? '14px' : '16px',
            color: '#1e40af',
            marginBottom: '16px',
            lineHeight: '1.5'
          }}>
            Ditt konto har skapats men väntar på godkännande från en administratör.
          </p>
          
          <p style={{ 
            fontSize: isMobile ? '13px' : '14px',
            color: '#1d4ed8',
            margin: 0,
            lineHeight: '1.4'
          }}>
            Du kommer att få tillgång till systemet så snart en administratör har granskat och godkänt ditt konto. Detta kan ta upp till 24 timmar.
          </p>
        </div>

        {/* User Info */}
        <div style={{
          backgroundColor: '#f8fafc',
          borderRadius: '8px',
          padding: isMobile ? '14px' : '16px',
          marginBottom: isMobile ? '24px' : '32px',
          textAlign: 'left'
        }}>
          <h3 style={{
            fontSize: isMobile ? '12px' : '14px',
            fontWeight: '600',
            color: '#64748b',
            marginBottom: '12px',
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
          }}>
            Kontoinformation
          </h3>
          <div style={{ fontSize: isMobile ? '13px' : '14px', color: '#475569', lineHeight: '1.6' }}>
            <div><strong>E-post:</strong> {user?.email}</div>
            {user?.jobTitle && <div><strong>Befattning:</strong> {user.jobTitle}</div>}
            {user?.officeLocation && <div><strong>Kontor:</strong> {user.officeLocation}</div>}
          </div>
        </div>

        {/* Actions */}
        <div style={{ 
          display: 'flex', 
          gap: isMobile ? '8px' : '12px', 
          justifyContent: 'center',
          flexDirection: isMobile ? 'column' : 'row'
        }}>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: isMobile ? '16px 24px' : '12px 24px',
              backgroundColor: '#2563eb',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: isMobile ? '16px' : '14px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              minHeight: isMobile ? '48px' : 'auto'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = '#1e40af'
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = '#2563eb'
            }}
          >
            Uppdatera status
          </button>
          
          <button
            onClick={logout}
            style={{
              padding: isMobile ? '16px 24px' : '12px 24px',
              backgroundColor: 'transparent',
              color: '#64748b',
              border: '1px solid #d1d5db',
              borderRadius: '8px',
              fontSize: isMobile ? '16px' : '14px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              minHeight: isMobile ? '48px' : 'auto'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = '#f8fafc'
              e.currentTarget.style.borderColor = '#9ca3af'
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent'
              e.currentTarget.style.borderColor = '#d1d5db'
            }}
          >
            Logga ut
          </button>
        </div>

        {/* Footer */}
        <div style={{
          marginTop: isMobile ? '32px' : '40px',
          paddingTop: isMobile ? '24px' : '30px',
          borderTop: '1px solid #e2e8f0'
        }}>
          <p style={{ 
            fontSize: isMobile ? '11px' : '12px',
            color: '#a0aec0',
            margin: 0
          }}>
            Kontakta din systemadministratör om du har frågor
          </p>
        </div>
      </div>
    </div>
  )
}